//------------------------------------------------------------------
// Description: Message queue object. The client interface component queues up messages till a response to the previous
//              message is received. This prevents current message clobbering the response from previous message and
//				also allows the application to not block.
//              This object is used exclusively by internal DSC client communication object.
//              Message queue component queues a message object type. A message object type can be created by the msgMaker
//              function.
//              This component does NOT guarantee message order. Specifically when a message is tagged latest only, it
//              REPLACES an already existing such message and potentially putting it ahead of other messages in the Queue. This
//              is the only case where order is not preserved. In all other cases, order is preserved.
// Author:      Kiran Saligrama
// Interface Description:
//              addMessage: Add a message to the queue. If the latest only flag is set, the last message with the same title is
//                          replaced else the message is added to the end of the queue.
//              getNextMessage: Returns the next message to be sent from the front of the Queue.
//              getQueueLength: Returns the message count currently in the Queue. Mostly used for debugging.
//              resetQueue: Clears the message Queue.
// 
// Date ------  Developer -- Description ----------------------------
// 14 Oct  2011 SK           Original
// 23 Oct  2011 SK           Add latest only feature
// 18 Nov  2011 SK           Fix missing message bug caused by wrong calculation of last message index
// 23 Jan  2012 SK           User dscConsoleLog rather than console.log. Prevents exceptions when debug console is not turned on
//------------------------------------------------------------------

var msgMaker = function (msgTitle, msgDataNode, msgType) 
{
	var m_msgTitle, m_msgDataNode, m_msgType;
	m_msgTitle = msgTitle;
	m_msgDataNode = msgDataNode;
	m_msgType = msgType;

	return {
		getType : function () {return m_msgType;},
		getDataNode : function () {return m_msgDataNode;},
		getTitle : function () {return m_msgTitle;}
	};
}
var dscMessageQueue = (function () {
	var ___DEBUG2___ = false;
	var privMsgQueue = [];
	var lastIndex = [];
	lastIndex[_dscMessageTypes.confManagementMessage] = -1;
	lastIndex[_dscMessageTypes.confAttributeMessage] = -1;
	lastIndex[_dscMessageTypes.confImagePositionUpdateMessage] = -1;
	lastIndex[_dscMessageTypes.confMarkerPositionUpdateMessage] = -1;
	lastIndex[_dscMessageTypes.confEventUpdateRegistration] = -1;

	function decrementIndicies() {
		for (var ind = 0; ind < lastIndex.length; ind++) {
			if (lastIndex[ind] >= 0)
				lastIndex[ind] -= 1;
		}
	}

	return {
		addMessage: function (msgObj, latestOnly) {
			var addInd = -1;
			var updateInd = false;
			var msgType = msgObj.getType();
			if (latestOnly)										//if latest only, figure out index of last queued msg (if any)
			{
				if (lastIndex[msgType] === undefined)			//unknown type, just add to end of queue
					addInd = -1;
				else
					addInd = lastIndex[msgType];
			}
			if (addInd === -1) {
				privMsgQueue[privMsgQueue.length] = msgObj;
				addInd = privMsgQueue.length - 1;				//the index itself one less than the length
			}
			else
				privMsgQueue[addInd] = msgObj;
			if (latestOnly && (lastIndex[msgType] !== undefined))   //remember index of latest only message
				lastIndex[msgType] = addInd;
			if(___DEBUG2___)
				dscConsoleLog("added message " + msgObj.getTitle() + " to the queue at index " + addInd);
		},
		getNextMessage: function () {
			if (privMsgQueue.length === 0)
				return null;
			var nxtMsg = privMsgQueue[0];
			privMsgQueue.splice(0, 1);
			decrementIndicies();
			if (___DEBUG2___)
				dscConsoleLog("returned message " + nxtMsg.getTitle());
			return nxtMsg;
		},
		getQueueLength: function () {
			return privMsgQueue.length;
		},
		resetQueue: function () {
			privMsgQueue = [];
			return;
		}
	}
}
)();
